import styled from "styled-components";

export const FilterWrapper = styled.div`
  position: relative;
  display: inline-block;
  z-index: 20;

  &.open {
    z-index: 100;
  }
`;

export const FilterButton = styled.button<{ active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: var(--white);
  border: 1px solid var(--fixit);
  color: var(--fixit);
  font-size: 14px;
  font-weight: 600;
  padding: 0 16px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  height: 38px;
  box-sizing: border-box;

  &:hover {
    background: rgba(152, 53, 209, 0.05);
  }

  svg {
    stroke-width: 2.5px;
  }
`;

export const DropdownContainer = styled.div<{ layout?: string }>`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: var(--white);
  border-radius: 12px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(0, 0, 0, 0.05);
  min-width: ${props => props.layout === "orders" ? "420px" : "320px"};
  display: flex;
  flex-direction: column;
  overflow: visible;

  @media (max-width: 768px) {
    min-width: unset;
    width: calc(100vw - 40px);
    max-width: 420px;
    left: 50%;
    right: auto;
    transform: translateX(-50%);
  }

  .groups-container {
    display: flex;
    flex-wrap: wrap;
    padding: 20px;
    gap: 32px;
    background: var(--white);
    border-radius: 12px 12px 0 0;

    @media (max-width: 768px) {
      padding: 16px;
      gap: 16px;
    }
  }
`;

export const ColumnsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;
  width: 100%;

  @media (max-width: 768px) {
    gap: 16px;
  }
`;

export const FilterColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1;

  @media (max-width: 768px) {
    gap: 16px;
  }
`;

export const FilterSection = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 140px;

  @media (max-width: 768px) {
    min-width: unset;
  }

  .options-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
`;

export const SectionTitle = styled.h4`
  font-size: 14px;
  font-weight: 700;
  color: var(--black);
  margin: 0 0 16px 0;
`;

export const RadioOption = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  position: relative;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  .radio-custom {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 2px solid var(--sub-title);
    display: inline-block;
    position: relative;
    transition: all 0.2s ease;

    &::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) scale(0);
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: var(--fixit);
      transition: all 0.2s ease;
    }
  }

  input:checked ~ .radio-custom {
    border-color: var(--fixit);
    &::after {
      transform: translate(-50%, -50%) scale(1);
    }
  }

  .label {
    font-size: 14px;
    color: var(--text);
    font-weight: 500;
    transition: color 0.2s ease;
  }

  input:checked ~ .label {
    color: var(--black);
    font-weight: 600;
  }

  &:hover .radio-custom {
    border-color: var(--fixit);
  }
`;

export const CheckboxOption = styled.label`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  position: relative;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  .checkbox-custom {
    width: 20px;
    height: 20px;
    border-radius: 5px;
    border: 2px solid var(--gray);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    transition: all 0.2s ease;
    background: var(--white);

    svg {
      opacity: 0;
      transform: scale(0);
      transition: all 0.2s ease;
      color: var(--white);
    }
  }

  input:checked ~ .checkbox-custom {
    border-color: var(--fixit);
    background: var(--fixit);
    
    svg {
      opacity: 1;
      transform: scale(1);
    }
  }

  .label {
    font-size: 15px;
    color: var(--dark-gray);
    font-weight: 400;
    transition: color 0.2s ease;
  }

  input:checked ~ .label {
    color: var(--black);
    font-weight: 500;
  }

  &:hover .checkbox-custom {
    border-color: var(--fixit);
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 16px 20px;
  background: var(--background);
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  gap: 12px;
  border-radius: 0 0 12px 12px;
`;
